import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=748a7575&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('748a7575')) {
      api.createRecord('748a7575', component.options)
    } else {
      api.reload('748a7575', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=748a7575&", function () {
      api.rerender('748a7575', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vfxGzR4HdcIJ/JS/comp/ImgFallback2.vue"
export default component.exports